import { SUBMIT_FORM_DEFAULT_ON_SUCCESS } from 'root/src/client/logic/form/actionIds'

export default payload => ({
	type: SUBMIT_FORM_DEFAULT_ON_SUCCESS,
	payload,
})
